export const LOGIN = 'login'

export const LOGOUT = 'logout'

export const USERINFO = 'userinfo'

export const SETTITLE = 'settitle'

export const SAVEEXAM = 'saveexam'

export const DELETEEXAM = 'deleteexam'

export const SAVEQUEST = 'savequest'

export const DELETEQUEST = 'deletequest'

export const SAVEPRODUCT = 'saveproduct'

export const DELETEPRODUCT = 'deleteproduct'

export const SAVESCROLLINFO = 'savescrollInfo'

export const DELETESCROLLINFO = 'deletescrollInfo'

export const SAVECOMPETITIONID = 'savecompetitionid'

export const DELETECOMPETITIONID = 'deletecompetitionid'
